import { useCallback, useEffect, useState } from 'react';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from '../lib/supabase';

/**
 * Sprawdza, czy backend Supabase odpowiada (Auth /health).
 * Nie gwarantuje poprawności schematu RLS - tylko osiągalność API.
 */
export function useSupabaseBackendStatus(pollMs = 45000) {
  const [backendOnline, setBackendOnline] = useState(null);

  const check = useCallback(async () => {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      setBackendOnline(false);
      return;
    }

    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 12000);

    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/health`, {
        method: 'GET',
        signal: controller.signal,
        headers: {
          apikey: SUPABASE_ANON_KEY,
        },
      });
      setBackendOnline(res.ok);
    } catch {
      setBackendOnline(false);
    } finally {
      window.clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    check();
    const id = window.setInterval(check, pollMs);
    return () => window.clearInterval(id);
  }, [check, pollMs]);

  useEffect(() => {
    const onBrowserOnline = () => {
      check();
    };
    const onBrowserOffline = () => {
      setBackendOnline(false);
    };
    window.addEventListener('online', onBrowserOnline);
    window.addEventListener('offline', onBrowserOffline);
    return () => {
      window.removeEventListener('online', onBrowserOnline);
      window.removeEventListener('offline', onBrowserOffline);
    };
  }, [check]);

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [check]);

  return { backendOnline, recheckBackend: check };
}
